/**
 * @ngdoc directive
 * @name cbl.telepass.wa.directive:tlpsDefinizioneProdotto
 * @restrict E
 * @description Componente che gestisce le configurazione Soglie del'Approvvigionamento Telepass
 */
(function() {
  'use strict';
  var PresaInCaricoBancaCtrl = function(
    $scope,
    $stateParams,
    CONSTANTS,
    labelSrvc,
    messaggiFctr,
    propostaTelepassSrvc,
    userSrvc,
    uiGridConstants,
    presaInCaricoBancaSrvc,
    $q,
    domainSrvc,
    $state
    // propostaDefinizioneSrvc
  ) {
    this.$stateParams = $stateParams;
    this.messaggiFctr = messaggiFctr;
    this.CONSTANTS = CONSTANTS;
    this.userSrvc = userSrvc;
    $scope.msg = labelSrvc.getLabel;
    this.uiGridConstants = uiGridConstants;
    this.presaInCaricoBancaSrvc = presaInCaricoBancaSrvc;
    this.$q = $q;
    this.domainSrvc = domainSrvc;
    this.$state = $state;

    this.propostaTelepassSrvc = propostaTelepassSrvc;
    // this.propostaDefinizioneSrvc = propostaDefinizioneSrvc;

    // Spinner
    this.spinner = this.propostaTelepassSrvc.spinner;

    this.gridOptions = {};

    this.stiliTabella = {
      height: '0px',
      width: '0px'
    };

    this.datepicker = {
      isOpen: false,
      dateOptions: {
        formatDay: 'dd',
        formatMonth: 'MM',
        formatYear: 'yyyy',
        startingDay: 1
      }
    };

    this.datepickerD = {
      isOpen: false,
      dateOptions: {
        formatDay: 'dd',
        formatMonth: 'MM',
        formatYear: 'yyyy',
        startingDay: 1
      }
    };

    this.tableHeight = 0;
    this.tableWidth = 0;

    this.ricerca = {
      stato: '',
      dataDal: '',
      dataAl: ''
    };

    this.minDate = null;
    this.maxDate = null;

    this.flusso = {};

    this.gestioneApparatiFl = false;

    this.flussi = [];

    /**
     * Riferimento alle API della griglia di ricerca
     */
    this.gridApi = null;

    var self = this;

    /*
     * -------------------------------------
     *          GESTIONE INTERFACCIA
     * -------------------------------------
     */

    /**
     * @ngdoc method
     * @name controllaApparatoInFlusso
     * @methodOf cbl.telepass.wa:presaInCaricoBancaCtrl
     * @description Controlla se il codice del apparato appartiene al flusso selezionato
     */
    this.controllaApparatoInFlusso = function(apparato) {
      for (var i in self.flusso.apparati) {
        if (self.flusso.apparati[i].codice === apparato.codice) {
          return true;
        }
      }
      var message = {};
      message.type = 'E';
      message.message =
        'Il codice apparato non appartiene al flusso selezionato'; //chiedere messaggio corretto
      messaggiFctr.addMessage(message);
      return false;
    };

    /**
     * @ngdoc method
     * @name controllaDatiValidi
     * @methodOf cbl.telepass.wa:presaInCaricoBancaCtrl
     * @description Controlla se il codice del apparato appartiene al flusso selezionato
     */
    this.controllaDatiValidi = function(apparato) {
      if (!apparato) {
        var message = {};
        message.type = 'E';
        message.message = 'Codice apparato e stato apparato non valorizzati'; //chiedere messaggio corretto
        messaggiFctr.addMessage(message);
        return false;
      }
      if (apparato && !apparato.codice) {
        var message = {};
        message.type = 'E';
        message.message = 'Codice apparato non valorizzato'; //chiedere messaggio corretto
        messaggiFctr.addMessage(message);
        return false;
      }
      if (apparato && !apparato.stato) {
        var message = {};
        message.type = 'E';
        message.message = 'Stato apparato non valorizzato'; //chiedere messaggio corretto
        messaggiFctr.addMessage(message);
        return false;
      }
      return true;
    };

    /**
     * @ngdoc method
     * @name salva
     * @methodOf cbl.telepass.wa:presaInCaricoBancaCtrl
     * @description Aggiorna lo stato del apparato
     */
    this.salva = function(apparato) {
      self.messaggiFctr.resetMessages();

      if (!self.controllaDatiValidi(apparato)) {
        return;
      }

      if (!self.controllaApparatoInFlusso(apparato)) {
        return;
      }

      self.spinner.showSpinner = true;

      self.presaInCaricoBancaSrvc
        .promiseAggiornaStatoApparato(self.flusso.id, apparato)
        .then(
          function(response) {
            self.spinner.showSpinner = false;

            if (self.messaggiFctr.processaResponse(response)) {
              return;
            }

            if (response.data.result) {
              self.apparato = {};
              self.gestioneApparatiFl = true;
              self.selezionaFlusso(self.flusso, true);
            }
          },
          function(error) {
            self.spinner.showSpinner = false;
            self.messaggiFctr.processaResponse(error);
          }
        );
    };

    this.chiudi = function(apparato) {
      self.messaggiFctr.resetMessages();
      self.spinner.showSpinner = true;

      self.presaInCaricoBancaSrvc.promiseChiudiFlusso(self.flusso).then(
        function(response) {
          self.spinner.showSpinner = false;

          if (self.messaggiFctr.processaResponse(response)) {
            return;
          }

          if (response.data.result) {
            var message = {};
            message.type = 'I';
            message.message = 'Ordine chiuso correttamente';
            self.messaggiFctr.addMessage(message);

            self.dettaglioFlusso = {};
            self.gestioneApparatiFl = false;

            // Aggiorno i flussi
            self.ricercaPresaInCaricoBanca(self.ricerca, self.flusso);
          }
        },
        function(error) {
          self.spinner.showSpinner = false;
          self.messaggiFctr.processaResponse(error);
        }
      );
    };

    /**
     * @ngdoc method
     * @name selezionaFlusso
     * @methodOf cbl.telepass.wa:tlpsDefinizioneProdotto
     * @description Seleziona o deseleziona il conto corrente su cui aprire la pratica
     */
    this.selezionaFlusso = function(flusso, flSalva) {
      if (!flSalva) {
        self.messaggiFctr.resetMessages();
        self.gestioneApparatiFl = false;

        if (
          !Object.keys(self.flusso).length ||
          flusso.entity.id !== self.flusso.id
        ) {
          self.flusso = flusso.entity;
        }
      }

      self.spinner.showSpinner = true;

      self.presaInCaricoBancaSrvc
        .promiseRecuperaFlussoDettaglio(self.flusso.id)
        .then(function(response) {
          if (self.messaggiFctr.processaResponse(response)) {
            self.spinner.showSpinner = false;
            return;
          }
          self.dettaglioFlusso = response.data.result;
        })
        .finally(function() {
          self.spinner.showSpinner = false;
        });
    };

    this.gestisci = function(flusso) {
      self.gestioneApparatiFl = true;
    };

    this.ricercaPresaInCaricoBanca = function(ricerca, flussoPreselezionato) {
      self.messaggiFctr.resetMessages();

      self.flusso = {};
      self.dettaglioFlusso = {};
      self.gestioneApparatiFl = false;

      if (!ricerca.stato) {
        ricerca.stato = null;
      }

      var dataDal = null;
      var dataAl = null;
      if (ricerca.dataDal) {
        var dataDalDay = ricerca.dataDal
          .getDate()
          .toString()
          .padStart(2, '0');
        var dataDalMonth = (ricerca.dataDal.getMonth() + 1)
          .toString()
          .padStart(2, '0');
        var dataDalYear = ricerca.dataDal.getFullYear();
        dataDal = dataDalYear + '-' + dataDalMonth + '-' + dataDalDay;
      }

      if (ricerca.dataAl) {
        var dataAlDay = ricerca.dataAl
          .getDate()
          .toString()
          .padStart(2, '0');
        var dataAlMonth = (ricerca.dataAl.getMonth() + 1)
          .toString()
          .padStart(2, '0');
        var dataAlYear = ricerca.dataAl.getFullYear();
        dataAl = dataAlYear + '-' + dataAlMonth + '-' + dataAlDay;
      }

      self.spinner.showSpinner = true;
      self.presaInCaricoBancaSrvc
        .promiseRecuperaFlussi(ricerca.stato, dataDal, dataAl)
        .then(
          function(response) {
            self.spinner.showSpinner = false;

            if (self.messaggiFctr.processaResponse(response)) {
              return;
            }

            self.flussi = response.data.result;
            self.tableHeight = self.flussi.length * 30 + 40;

            self.stiliTabella = {
              height: self.tableHeight + 'px'
              // width: '800px'
            };

            // Configurazione tabella
            self.gridOptions = {
              enableSorting: true,
              enableColumnMenus: false,
              enableGrouping: false,
              multiSelect: false,
              // showHeader: true,
              enableRowHeaderSelection: false,
              enableRowSelection: true,
              // enableRowSelection: !self.propostaTelepassSrvc.isPraticaNavigabile(),
              // showGridFooter: false,
              enableVerticalScrollbar: self.uiGridConstants.scrollbars.NEVER,
              enableHorizontalScrollbar: self.uiGridConstants.scrollbars.NEVER,
              enableColumnResizing: false,
              // enableCellEditing: false,
              columnDefs: [
                {
                  displayName: 'Data',
                  field: 'data',
                  width: '25%',
                  name: 'data'
                },
                {
                  displayName: 'Flusso',
                  field: 'id',
                  width: '25%',
                  name: 'flusso'
                },
                {
                  displayName: 'Stato',
                  field: 'stato.descrizione',
                  width: '25%',
                  name: 'stato'
                },
                {
                  displayName: 'Quantità',
                  field: 'quantita',
                  width: '25%',
                  name: 'quantita'
                }
              ],
              data: self.flussi,
              onRegisterApi: function(gridApi) {
                self.gridApi = gridApi;
                self.gridApi.selection.on.rowSelectionChanged($scope, function(
                  row
                ) {
                  self.selezionaFlusso(row);
                });
              }
            };

            // Se ho preselezionato un flusso, lo riseleziono
            if (
              flussoPreselezionato &&
              self.gridApi &&
              self.gridOptions.data &&
              self.gridOptions.data.length > 0
            ) {
              for (var i = 0; i < self.gridOptions.data.length; i++) {
                if (self.gridOptions.data[i].id === flussoPreselezionato.id) {
                  self.gridApi.grid.modifyRows(self.gridOptions.data);
                  self.gridApi.selection.selectRow(self.gridOptions.data[i]);
                }
              }
            }
          },
          function(reason) {
            self.spinner.showSpinner = false;
            self.messaggiFctr.processaResponse(reason);
          }
        );
    };

    /*
     * -------------------------------------
     * METODI INIZIALIZZAZIONE
     * -------------------------------------
     */

    this.init = function() {
      document.body.style.overflowY = 'scroll';
      labelSrvc.labelsPronte.then(function() {
        self.spinner.showSpinner = true;
        self.labelsPronte = true;
        $q.all([
          self.domainSrvc.promiseDomain('APPARATO'),
          self.domainSrvc.promiseDomain('ORDINE'),
          self.domainSrvc.promiseDomain('MAGAZZINO')
        ])
          .then(function(responses) {
            self.statiFlussi = responses[1];
            self.statiApparato = responses[0];
          })
          .finally(function() {
            self.spinner.showSpinner = false;
          });
      });
    };

    /*
     * -------------------------------------
     *        INIZIALIZZAZIONE
     * -------------------------------------
     */
    self.init();
  };

  PresaInCaricoBancaCtrl.$inject = [
    '$scope',
    '$stateParams',
    'TLPS_CONSTANTS',
    'TlpsLabelSrvc',
    'TlpsMessaggiFctr',
    'TlpsPropostaSrvc',
    'TlpsUserSrvc',
    'uiGridConstants',
    'TlpsPresaInCaricoBancaSrvc',
    '$q',
    'TlpsDomainSrvc',
    '$state'
    // 'TlpsDefinizioneSrvc'
  ];

  var TemplateUrl = function(CONSTANTS) {
    return (
      CONSTANTS.BASE_ROOT +
      CONSTANTS.COMPONENTS_PATH +
      'tlpsApprovvigionamento/presaInCarico/presaInCaricoBanca/presaInCaricoBanca.html'
    );
  };

  TemplateUrl.$inject = ['TLPS_CONSTANTS'];

  var presaInCaricoBancaComponent = {
    bindings: {
      steps: '<',
      currentStep: '<'
    },
    controller: PresaInCaricoBancaCtrl,
    controllerAs: 'presaInCaricoBancaCtrl',
    templateUrl: TemplateUrl
  };

  angular
    .module('cbl.telepass.wa')
    .component('presaInCaricoBanca', presaInCaricoBancaComponent);
})();



//////////////////
// WEBPACK FOOTER
// ./app/components/tlpsApprovvigionamento/presaInCarico/presaInCaricoBanca/presaInCaricoBanca.cmpt.js
// module id = 12
// module chunks = 0